<template>
  <div id='layout'>
    <Head style="position: relative" @contactUs="contactUs"></Head>
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive" :key="key"></router-view>
    </keep-alive>
    <router-view v-if="!this.$route.meta.keepAlive" :key="key"></router-view>

    <RightTools></RightTools>
    <Footer></Footer>
    <!-- 估价/合同通知 -->
    <el-dialog
      :visible.sync="vitimateSubmission"
      custom-class="Unpublished"
      :show-close="false"
      width="342px"
      top="35vh"
      center>
          <span>
            <div id="vi_main">
              <div class="UPS_info">
                <div class="UPS_name">{{ site_status == 1 ? '估价报告' : '合同报告' }}</div>
                <div class="UPS_con">{{ site_status == 1 ? '您的估价报告已放入通知列表' : '您的合同信息已放入通知列表' }}</div>
              </div>
              <div class="UPS_btn">
                <button class="UPS_continue ESconfirm" @click="viNotice()">查看</button>
              </div>
            </div>
            <img class="UPS_close" src="@/assets/image/AccountDeal/close.png" alt=""
                 @click="vitimateSubmission = false">
          </span>
    </el-dialog>
    <!-- 补充信息 -->
    <el-dialog
      :visible.sync="replenishInfoDia"
      custom-class="replenish_info"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="400px"
      top="20vh"
      center>
      <div slot="title">补充信息</div>
      <el-form :model="infoForm" :rules="rules" ref="infoForm" class="demo-ruleForm" label-position="top">
        <el-form-item label="用户头像：" class="userImg">
          <div class="personal_info">
            <el-upload
              class="basicInfo-uploader"
              :show-file-list="false"
              action
              :auto-upload="false"
              :on-change="avatarChange">
              <img v-if="imageUrl" :src="imageUrl" class="basicInfo">
              <img v-else-if="infoForm.touxiang" :src="infoForm.touxiang" class="basicInfo">
              <i v-else class="el-icon-plus basicInfo-uploader-icon"></i>
              <el-button size="small" type="primary" class="basicInfo-upload-btn">{{ elUploadBtn }}</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="昵称" prop="account">
          <el-input placeholder="请输入昵称" v-model="infoForm.account"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input placeholder="请输入电子邮箱" v-model="infoForm.email"></el-input>
        </el-form-item>
        <el-form-item label="QQ号" prop="qq_num">
          <el-input placeholder="请输入QQ号" v-model="infoForm.qq_num"></el-input>
        </el-form-item>

      </el-form>
      <button class="basicInfo-btn" @click.stop="saveUserInfo('infoForm')">提交信息</button>
      <!-- <img class="UPS_close" src="@/assets/image/AccountDeal/close.png" alt="" @click="replenishInfoDia = false"> -->
    </el-dialog>

    <!-- 联系我们 -->
    <el-dialog
      :visible.sync="contactUsShow"
      custom-class="contactUsDialog"
      :show-close="false"
      width="440px"
      top="35vh"
      center>
      <div class="contactUsDialog-card">
        <div class="contactUsDialog-body">
          <div class="contactUsDialog-body-item">
            <div class="contactUsDialog-body-item-label">账号/道具/金币商户合作邮箱</div>
            <div class="contactUsDialog-body-item-value" @click="copy(businessEmail)">{{ businessEmail }}</div>
          </div>
          <div class="contactUsDialog-body-item">
            <div class="contactUsDialog-body-item-label">企业合作邮箱</div>
            <div class="contactUsDialog-body-item-value" @click="copy(enterpriseEmail)">{{ enterpriseEmail }}</div>
          </div>
          <div class="contactUsDialog-body-name">
            <i class="el-icon-s-cooperation"></i>
            博淳网络科技有限公司
          </div>
          <input type="text" id="contactUsDialog-body-input" />
        </div>
        <div class="contactUsDialog_close">
          <img src="@/assets/image/AccountDeal/close.png" alt="" @click="contactUsShow = false">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Footer from '@/components/footer'
import Head from '@/components/head'
import RightTools from '@/components/RightTools/index'
import {apiUserSave, apiuserInfo, apiUploadAvatar} from "@/request/API";
import chatApi from '@/request/customer/customerRoom'

export default {
  name: '',
  props: {},
  components: {
    Footer,
    Head,
    RightTools,
  },
  data() {
    return {
      appDownload: true,
      vitimateSubmission: false,
      replenishInfoDia: false,
      site_status: 1,
      infoForm: {
        account: '',
        ph_num: this.$store.state.userData.telphone,
        email: this.$store.state.userData.email,
        qq_num: this.$store.state.userData.qq,
        touxiang: this.$store.state.userData.touxiang,
      },
      //头像
      imageUrl: '',
      //完整头像地址
      file_path: '',
      //上传按钮文本
      elUploadBtn: '点击上传',
      //表单验证
      rules: {
        account: [
          {required: true, message: '请输入昵称', trigger: 'blur'},
          {min: 1, max: 15, message: '请输入1-15个字符的昵称', trigger: 'change'}
        ],
        // ph_num:[
        //   { required: true, message: '请输入用户手机号码', trigger: 'blur' },
        //   { min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur' }
        // ],
        email: [
          {pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/, message: '邮箱格式错误'}
        ],
        qq_num: [
          {pattern: /^[1-9][0-9]{4,9}$/, message: 'QQ账号格式错误'}
        ],
      },
      //联系我们弹窗
      contactUsShow: false,
      businessEmail: 'xxx@163.com',
      enterpriseEmail: 'xxx@163.com'
    }
  },
  methods: {
    /**
     * @description: 提交用户信息
     * @return {*}
     */
    saveUserInfo(formName) {
      // console.log(123);
      // return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // return
          apiUserSave({
            nickname: this.infoForm.account,
            phone: this.infoForm.ph_num,
            qq: this.infoForm.qq_num,
            email: this.infoForm.email,
            touxiang: this.infoForm.touxiang
          }).then(res => {
            this.$message({
              message: "提交成功",
              type: "success",
              center: true
            })
            let userData = this.$store.state.userData
            userData.touxiang = this.file_path
            // userData.telphone = this.infoForm.ph_num
            userData.nickname = this.infoForm.account
            this.$store.commit('set_userData', userData)
            this.replenishInfoDia = false
            apiuserInfo({
              action: 'base'
            }).then(res => {
              this.$store.commit('user_BasicInfo', res.data)
            })
          }).catch(err => {
            this.$message({
              message: err.msg,
              type: "error",
              center: true
            })
          })
          // 更新用户信息
          chatApi.updatecustomerinfo({
            msg: chatApi.encryptMsg({
              customerid: this.infoForm.ph_num,
              format: 'json',
              headimg: this.infoForm.touxiang ? this.infoForm.touxiang : 'https://images.pxb7.com/images/upload/avatar/20221009/1665300146651430.png',
              nickname: this.infoForm.account
            })
          }).then().catch()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    avatarChange(file) {
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        return
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
        return
      }
      let data = new FormData()
      data.append('file', file.raw)
      apiUploadAvatar(data).then(res => {
        this.infoForm.touxiang = res.data.file_path
      }).catch(err => {
        this.$message({
          type: "error",
          center: true,
          message: err.msg + '(5M以内的png或jpg格式的图片)'
        })
      })
    },
    // beforeAvatarUpload(file) {
    //   const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    //   const isLt5M = file.size / 1024 / 1024 < 5;
    //   if (!isJPG) {
    //     this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
    //   }
    //   if (!isLt5M) {
    //     this.$message.error('上传头像图片大小不能超过 5MB!');
    //   }
    //   return isJPG && isLt5M;
    // },
    //头像上传
    // handleAvatarSuccess(res, file,fileList) {
    //   if(res.code === 200){
    //     // let response = JSON.parse(Decrypt(res.data, 'C01F8012D3F6386C', '245C3EA487E944FD'))
    //     this.imageUrl = URL.createObjectURL(file.raw);
    //     this.infoForm.touxiang = res.data.src;
    //     this.file_path = res.data.file_path;

    //   }else{
    //     this.$message({
    //       message:res.msg+" (上传头像图片只能是 JPG/PNG 格式)",
    //       center:true,
    //       type:"error"
    //     })
    //   }
    // },
    getQinMingJieDate() {
      let date = new Date()
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      //清明节的日期是不固定的，规律是：闰年开始的前2年是4月4日，闰年开始的第3年和第4年是4月5日
      if (this.isLeapYear(fullYear) || this.isLeapYear(fullYear - 1)) {
        return month === 4 && day === 4;
      } else {
        return month === 4 && day === 5;
      }
    },
    //判断是否是闰年
    isLeapYear(Year) {
      if (((Year % 4) === 0) && ((Year % 100) !== 0) || ((Year % 400) === 0)) {
        return true;
      } else {
        return false;
      }
    },
    // 估价通知
    viNotice() {
      this.$router.push('/personalCenter/siteNotice')
      this.vitimateSubmission = false
    },

    /**
     * 联系我们
     */
    contactUs() {
      this.contactUsShow = true
    },
    copy(v) {
      var input = document.getElementById("contactUsDialog-body-input");
      input.value = v; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$message({
        type: "success",
        center: true,
        message: "复制成功",
      });
    },
  },
  created() {
    this.$WS.on('assess_tip', (e) => {
      this.site_status = 1
      this.vitimateSubmission = true
    })
    this.$WS.on('contractNotice', (e) => {
      this.site_status = 2
      this.vitimateSubmission = true
    })
  },
  mounted() {
    if ((this.$store.state.userData.telphone == this.$store.state.userData.nickname || this.$store.state.userData.nickname == '') && this.$store.state.loginStatus) {
      this.replenishInfoDia = true
    }
  },
  watch: {
    imageUrl() {
      if (this.imageUrl !== '') {
        this.elUploadBtn = '重新上传'
      }
    }
  },
  computed: {
    key() {
      return this.$route.path
    },
//     style() {
//       let style = ''
//       let date = new Date()
//       let month = date.getMonth() + 1
//       let day = date.getDate()
//       if (this.$route.name === 'Home') {
//         if (month === 12 && day === 13) {
//           // style = 'filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);-webkit-filter: grayscale(100%)'
//           this.$nextTick(() => {
//             let html = document.getElementById('layout')
//             html.className = 'filterBlack'
//           })
//           //南京大屠杀
//           // style = 'filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);-webkit-filter: grayscale(100%)'
//         }
// /*        else if (this.getQinMingJieDate()) {
//           //清明节
//           style = 'filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);-webkit-filter: grayscale(100%)'
//         }*/
//       } else{
//         this.$nextTick(() => {
//           let html = document.getElementById('layout')
//           html.className = ''
//         })
//       }
//       return style
//     },
  }
}
</script>
<style lang="less">
.filterBlack {
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(100%)
}

.nofilter {
  filter: none
}

.Unpublished.el-dialog {
  border-radius: 4px;
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: 0 18px 46px rgba(26, 29, 36, 0.16);

  .el-dialog__header {
    display: none;
    padding: 0;
  }
}

.replenish_info {
  &.el-dialog {
    border-radius: 4px;
    box-shadow: 0 18px 46px rgba(26, 29, 36, 0.14);
    overflow: hidden;
  }

  .el-dialog__header {
    padding: 0;
    width: 400px;
    height: 53px;
    background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
    border-radius: 4px 4px 0 0;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 53px;
    letter-spacing: 1px;
  }

  .basicInfo-uploader .el-upload {
    border: 1px dashed var(--border-strong, #CBD5E1);
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    transition: border-color 0.2s ease;
    // display: flex;
    // justify-content: flex-start;
    /*overflow: hidden;*/
  }

  .basicInfo-upload-btn {
    position: absolute;
    top: 13px;
    left: 90px;
    width: 100px;
    height: 32px;
    background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%)) !important;
    border-radius: 4px;
    border: none;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    padding: 0;
    line-height: 32px;
    text-align: center;
  }

  .basicInfo-upload-btn:hover {
    background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%)) !important;
    box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
  }

  .basicInfo-uploader .el-upload:hover {
    border-color: var(--brand-blue, #1A1D24);
  }

  .basicInfo-uploader-icon {
    font-size: 28px;
    color: var(--text-muted, #9AA0AC);
    width: 62px;
    height: 62px;
    line-height: 62px;
    text-align: center;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .el-form--label-top .el-form-item__label {
    padding: 0;
    color: var(--text-secondary, #5A5F6B);
    font-weight: 500;
  }

  .el-input__inner {
    height: 38px;
    line-height: 38px;
    color: var(--text-main, #111827);
    border-color: var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-section, #F7F5F2);
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

    &:hover {
      border-color: var(--border-strong, #CBD5E1);
    }

    &:focus {
      border-color: var(--brand-blue, #1A1D24);
      background: #FFFFFF;
      box-shadow: 0 0 0 3px rgba(26, 29, 36, 0.1);
    }
  }

  .el-dialog__body {
    padding: 28px 50px 38px !important;
    background: var(--bg-card, #FFFFFF);
  }
}
</style>
<style lang='less' scoped>
#layout {
  width: 100vw;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-page, #F7F5F2);
  //overflow: hidden;
  .replenish_info {
    position: relative;

    .el-dialog__header {
      font-size: 20px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
    }

    .basicInfo-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      cursor: pointer;
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      /*overflow: hidden;*/
    }

    .personal_info {
      font-size: 16px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 300;
      color: var(--text-secondary, #5A5F6B);
      padding: 0 0 0 20px;
    }

    .basicInfo {
      width: 60px;
      height: 60px;
      display: block;
      border-radius: 4px;
      object-fit: cover;
    }

    .userImg {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .UPS_close {
      position: absolute;
      bottom: -47px;
      left: 185px;
      cursor: pointer;
      width: 30px;
      height: 30px;
    }

    .basicInfo-btn {
      margin-top: 10px;
      border: none;
      width: 300px;
      height: 42px;
      background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
      border-radius: 4px 4px 4px 4px;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
      transition: box-shadow 0.2s ease, transform 0.2s ease, opacity 0.2s ease;

      &:hover {
        box-shadow: 0 10px 22px rgba(26, 29, 36, 0.2);
        transform: translateY(-1px);
      }

      &:active {
        opacity: 0.9;
        transform: translateY(0);
      }
    }
  }

  .appDownload {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 80px;
    background: rgba(40, 55, 72, 0.6);
    z-index: 999999;

    .btn {
      margin: 0 30px;
      position: absolute;
      right: 0;
      cursor: pointer;
    }

    .ad-conetnt {
      width: 1200px;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;

      .conetnt {
        height: 60px;
        object-fit: contain;
      }

      .qrcode {
        position: absolute;
        bottom: 12px;
        right: 0;
      }
    }
  }

  .Unpublished {
    width: 342px;
    background: var(--bg-card, #FFFFFF);
    border-radius: 4px;
    position: relative;
    overflow: visible;

    .el-dialog__body {
      padding: 26px 30px 26px;
      position: relative;

      #vi_main {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        &::before {
          content: '';
          width: 44px;
          height: 44px;
          margin: 0 0 14px;
          border-radius: 4px;
          background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
          box-shadow: 0 12px 26px rgba(26, 29, 36, 0.22);
        }

        &::after {
          content: '';
          position: absolute;
          top: 14px;
          left: 50%;
          width: 18px;
          height: 10px;
          border-left: 3px solid #FFFFFF;
          border-bottom: 3px solid #FFFFFF;
          transform: translateX(-50%) rotate(-45deg);
          border-radius: 1px;
        }

        .UPS_info {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          min-height: 60px;
          margin: 0 0 18px;

          .UPS_name {
            align-self: center;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 600;
            color: var(--text-main, #111827);
            line-height: 28px;
            margin: 0 0 6px;
          }

          .UPS_con {
            width: 100%;
            min-height: 22px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            line-height: 22px;
            text-align: center;
          }
        }

        .UPS_btn {
          display: flex;
          justify-content: space-between;

          > button {
            display: inline-block;
            width: 139px;
            height: 38px;
            border-radius: 4px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            text-align: center;
            line-height: 38px;
            cursor: pointer;
            transition: box-shadow 0.2s ease, transform 0.2s ease, opacity 0.2s ease;

            &:hover {
              box-shadow: 0 10px 20px rgba(26, 29, 36, 0.22);
              transform: translateY(-1px);
            }

            &:active {
              opacity: 0.9;
              transform: translateY(0);
            }
          }

          .UPS_reset {
            border: 1px #000000 solid;
            background-color: #fff;
            margin-right: 14px;
          }

          .UPS_continue {
            border: none;
            background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
          }

          .ESconfirm {
            width: 233px;
            height: 40px;
            line-height: 40px;
          }
        }
      }

      .UPS_close {
        position: absolute;
        bottom: -46px;
        left: 156px;
        cursor: pointer;
        width: 30px;
        height: 30px;
      }
    }
  }
}

/deep/ .contactUsDialog {
  background: transparent;
  box-shadow: none;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;

    .contactUsDialog-card {
      position: relative;
      padding: 0;
      width: 440px;
      min-height: 276px;
      background: var(--bg-card, #FFFFFF);
      border-radius: 4px;
      box-shadow: 0 18px 46px rgba(26, 29, 36, 0.14);
      overflow: visible;

      .contactUsDialog-body {
        position: relative;
        padding: 78px 28px 24px;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 54px;
          border-radius: 4px 4px 0 0;
          background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
        }

        &::after {
          content: '联系我们';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 54px;
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 54px;
          text-align: center;
          letter-spacing: 1px;
        }

        &-item {
          background: linear-gradient(135deg, #FFFFFF 0%, var(--bg-section, #F7F5F2) 100%);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          width: 384px;
          height: 74px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 0 0 12px;
          box-sizing: border-box;
          transition: border-color 0.22s ease, box-shadow 0.22s ease, transform 0.22s ease;

          &:hover {
            border-color: rgba(26, 29, 36, 0.35);
            box-shadow: 0 10px 24px rgba(26, 29, 36, 0.12);
            transform: translateY(-1px);
          }

          &-label {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 500;
            color: var(--text-secondary, #5A5F6B);
            line-height: 20px;
            letter-spacing: 0;
            margin: 0 0 4px;
          }

          &-value {
            font-size: 20px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 600;
            color: var(--brand-blue, #1A1D24);
            line-height: 24px;
            letter-spacing: 1px;
            text-decoration-line: underline;
            cursor: pointer;
            transition: color 0.22s ease, transform 0.22s ease;

            &:hover {
              color: #1A1D24;
              transform: translateY(-1px);
            }
          }
        }

        &-name {
          padding: 3px 0 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-family: PingFang SC-Light, PingFang SC;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          letter-spacing: 1px;

          i {
            margin: 0 6px 0 0;
            font-size: 17px;
            color: var(--brand-blue, #1A1D24);
          }
        }

        input {
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          z-index: -10;
        }
      }
      .contactUsDialog_close {
        position: absolute;
        left: 0;
        bottom: -46px;
        width: 100%;
        margin: 0;
        text-align: center;

        img {
          width: 30px;
          height: 30px;
          cursor: pointer;
          transition: opacity 0.22s ease, transform 0.22s ease;

          &:hover {
            opacity: 0.82;
            transform: scale(1.06);
          }
        }
      }
    }
  }
}

</style>
